<script lang="ts" setup>
import * as _ from 'lodash-es'
import Filter from '../Filter.vue'
import FloatLabel from 'primevue/floatlabel'
import Dropdown from 'primevue/dropdown'
import { formatList } from '@/lib/helpers'
import { on } from 'events'

const filterInputStore = useFilterInputStore()
const { getGndIds, getWikidataIds } = useRemoteData()

const clonedFilterData = useClonedObject(filterInputStore.values)

function onCancel() {
  clonedFilterData.cancel()
}

function onCommit() {
  clonedFilterData.commit()
}

const options = ['gndId', 'wikidataId'] as const

const isActive = computed(() => options.some(option => filterInputStore.isOptionActive[option]))

function onClear() {
  filterInputStore.reset({ include: options })
}
</script>

<template>
  <FilterGroup
    name="Normdaten"
    :active="isActive"
    @cancel="onCancel"
    @commit="onCommit"
    @clear="onClear"
  >
    <template #icon>
      <!-- prettier-ignore -->
      <svg width="20" height="20" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M256.1 220.5c70.3 0 127.5 61.3 127.5 136.6v18.4a17.2 17.2 0 0 1-34.5 0V357c0-56.4-41.7-102.2-93-102.2s-93 45.8-93 102.2c0 58.5 47 90 73.3 128a17.2 17.2 0 0 1-28.3 19.6c-24.4-35.1-79.4-74.4-79.4-147.6 0-75.3 57.2-136.6 127.4-136.6Zm0-73.5c148.5 0 243.2 166.5 190 273-41.2 82.4-170.4 56.3-170.4-44.5 0-23.5-6-47.1-19.6-47.1-14.8 0-25.8 18.4-20.2 42.2l.2.7a17.2 17.2 0 1 1-33.4 8.3C179.3 286 310 247.7 310 375.5c0 64.6 80.3 78.7 105.2 29 23.9-47.8 7.5-120.4-38.2-169a167.5 167.5 0 0 0-121-54c-88.7 0-166.5 77.7-166.5 166.4 0 41.6 6.3 65.4 23.9 90.3l.5.8a17.2 17.2 0 1 1-28 20c-25.6-35.8-30.8-70.3-30.8-111 0-112.4 96.4-201 201-201Zm0-73.5c75.7 0 168.4 40.6 207.9 109.7a17.2 17.2 0 0 1-29.7 17.4l-.2-.3c-34.3-60-117.3-92.4-178-92.4-61.3 0-143.7 42.8-177.5 92l-1 1.4a17.2 17.2 0 0 1-28.7-19.1c40-60 134-108.7 207.2-108.7ZM443 67.7a17.2 17.2 0 0 1-20.5 27.6c-106-78.6-217.2-82-327.3-3.7L91.7 94a17.2 17.2 0 0 1-20.2-28c123-89.4 251.9-87.1 371.4 1.6Z"/></svg>
    </template>
    <template #body>
      <FloatLabel>
        <RemoteAutoComplete
          v-model="clonedFilterData.data.gndId"
          :get-suggestions="getGndIds"
          option-label="name"
          multiple
        />
        <label>GND ID</label>
      </FloatLabel>
      <FloatLabel>
        <RemoteAutoComplete
          v-model="clonedFilterData.data.wikidataId"
          :get-suggestions="getWikidataIds"
          option-label="name"
          multiple
        />
        <label>Wikidata-ID</label>
      </FloatLabel>
    </template>
    <template #summary>
      <div v-if="filterInputStore.isOptionActive.gndId">
        GNDs:
        <strong>{{ formatList(_.map(filterInputStore.values.gndId, 'name')) }}</strong>
      </div>
      <div v-if="filterInputStore.isOptionActive.wikidataId">
        Wikidata IDs:
        <strong>{{ formatList(_.map(filterInputStore.values.wikidataId, 'name')) }}</strong>
      </div>
    </template>
  </FilterGroup>
</template>

<style scoped></style>
